export default {
  POLL_QUIZS_FETCHED: 'POLL_QUIZS_FETCHED',
  POLL_QUIZ_LOAD: 'POLL_QUIZ_LOAD',
  POLL_QUIZ_DETAIL: 'POLL_QUIZ_DETAIL',
  RESEARCH_TEMPLATES_FETCHED: 'RESEARCH_TEMPLATES_FETCHED',
  RESEARCH_TEMPLATES_LOAD: 'RESEARCH_TEMPLATES_LOAD',
  POLL_QUIZ_BUTTON_LOAD: 'POLL_QUIZ_BUTTON_LOAD',
};
